import axios from "axios";

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname.includes("develop") ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

const api = axios.create({
  baseURL: "https://api.datasales.info",
});

const handleBeforeRequest = (config) => {
  const production = isLocalhost ? "prd" : "prd";
  config.url = config.url.replace(/prd/gi, production);

  return config;
};

api.interceptors.request.use(handleBeforeRequest);

export default api;
